import { stats, testimonials } from "@/mocks/fun";
import Reveal from "@/components/base/Reveal";

interface CommunityProps {
  onGoContribute: () => void;
}

export default function Community({ onGoContribute }: CommunityProps) {
  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-[1fr_1.05fr] lg:gap-14">
          {/* brand intro */}
          <Reveal>
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-semibold text-accent-800">
                <i className="ri-emotion-happy-line"></i> 关于 55吃瓜
              </span>
              <h2 className="mt-3 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
                把大家的“丢人现场”，
                <br />
                做成治愈社畜的快乐源泉
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
                55吃瓜是一群爱笑星人运营的爆笑内容站。我们相信，成年人的疲惫需要用“别人的社死”和“离谱的生活碎片”来对冲。
                我们不做严肃新闻，只负责在每天的一地鸡毛里，替你翻出那几颗闪着光的笑点，再用接地气的吐槽和表情包把它端上桌。
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
                我们的内容原则很朴素：<span className="font-semibold text-foreground-800">真实打底、演绎增味、绝不引战</span>。
                每一条稿子都尽量对真实投稿脱敏处理，只保留笑点，不泄露隐私，也希望屏幕前的你笑完把烦恼放下就好。
              </p>

              <div className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-4">
                {stats.map((s) => (
                  <div key={s.label} className="rounded-2xl bg-background-50 p-4 text-center">
                    <p className="font-heading text-2xl text-primary-600">{s.value}</p>
                    <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          {/* testimonials */}
          <Reveal delay={80}>
            <div className="flex flex-col gap-4">
              <h3 className="font-heading text-xl text-foreground-950 md:text-2xl">网友都在说</h3>
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-3xl bg-background-50 p-5 md:p-6">
                  <div className="flex items-center gap-0.5 text-accent-500" aria-label="五星好评">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-[15px]">
                    “{t.text}”
                  </blockquote>
                  <figcaption className="mt-3 flex items-center gap-2.5 text-sm">
                    <span className="grid h-9 w-9 place-items-center rounded-full bg-secondary-100 text-secondary-900">
                      <i className="ri-user-smile-line"></i>
                    </span>
                    <span>
                      <span className="block font-semibold text-foreground-900">{t.name}</span>
                      <span className="block text-xs text-foreground-500">{t.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
              <button
                onClick={onGoContribute}
                className="mt-1 flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-chat-smile-3-line"></i>
                你的瓜，也想被围观吗？
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}